import RobotFly from "../assets/pictures/robot_fly.gif";
import RobotPoof from "../assets/pictures/robot-poof.gif";
import "../styles/animation.css";

export default function Animation(props) {
  return (
    <div className={props.backgroundStyle}>
      <div className="background-container">
        <div className={props.forestStyle}></div>
        <div className={props.forestStyle}></div>
        <div className={props.forestStyle}></div>
        <div className={props.forestStyle}></div>
      </div>

      <img
        src={RobotFly}
        className={props.robotStyle}
        alt="Animation error"
        id="robot-fly"
      ></img>

      <img
        src={RobotPoof}
        className={props.poofStyle}
        alt="Animation error"
        id="robot-poof"
      ></img>
    </div>
  );
}
